import initialState from './initialState';
import {fetchBrands} from '../logic/api/catalog.js';

export const getBrands = () => (dispatch) => {
  dispatch({
    type: 'CATEGORIES:FETCH-BRAND-LIST'
  });

  fetchBrands()
  .then((res) => dispatch(onGetBrandsSuccess(res.brands)))
  .catch((err) => dispatch(onGetBrandsFail(err)));  
};

export const onGetBrandsSuccess = (brandList) => ({
  type: 'CATEGORIES:FETCH-BRAND-LIST-SUCCESS',
  brandList: brandList
});

export const onGetBrandsFail = (err) => ({
  type: 'CATEGORIES:FETCH-BRAND-LIST-FAIL',
  err
});

export default function categoriesReducer(state = initialState.categoriesState, action) {
  switch(action.type) {
    case 'CATEGORIES:FETCH-BRAND-LIST-SUCCESS': {
      return {
        ...state,
        brandList: action.brandList
      };
    }

    case 'CATEGORIES:FETCH-BRAND-LIST-FAIL': {
      return {
        ...state,
        err: action.err
      };
    }

    default:
      return state;
  }
}



/** WEBPACK FOOTER **
 ** ./src/redux/categoriesActions.js
 **/